import mfe88 from '@/utils/mfe88'
import pge from '@/utils/passGuard/PassGuardCtrl'
const pgeditorFn = function(id, num, regExp1, regExp2, placeHolder = '') {
  if (mfe88.env === 'local' || mfe88.env === 'dev' || mfe88.env === 'test' || mfe88.env === 'pet') {
    return new pge.Pge({
      pgePath: './ocx/',
      pgeId: id,
      pgeEdittype: 0,
      pgeEreg1: regExp1,
      pgeEreg2: regExp2,
      pgeMaxlength: 20,
      pgeTabindex: 2,
      pgeClass: 'ocx_style',
      pgeInstallClass: 'ocx_style',
      pgeOnkeydown: '',
      pgePlach: placeHolder,
      tabCallback: 'input2',
      pgeCert:
        '3081890281810092D9D8D04FB5F8EF9B8374F21690FD46FDBF49B40EECCDF416B4E2AC2044B0CFE3BD67EB4416B26FD18C9D3833770A526FD1AB66A83ED969AF74238D6C900403FC498154EC74EAF420E7338675CAD7F19332B4A56BE4FF946B662A3C2D217EFBE4DC646FB742B8C62BFE8E25FD5DC59E7540695FA8B9CD5BFD9F92DFAD009D230203010001',
      AffineX: '269F92157DE1FE1396D8FAB2B394F05A9D8C23289084E4B2AE5A0828D8601EEC',
      AffineY: 'ED4556A10E26B3E128D8223E60766929363A4E55F83D7D763971E75532F76AF6',
      pgeWindowID: 'password' + new Date().getTime() + num,
      pgeRZRandNum: '26043592843818248016850281040623',
      pgeRZDataB: '3kgnuB5r1V4Y045V8haV3+fk08lv7m2oRnZdK0Ss0Jg='
    })
  } else {
    return new pge.Pge({
      pgePath: './ocx/',
      pgeId: id,
      pgeEdittype: 0,
      pgeEreg1: regExp1,
      pgeEreg2: regExp2,
      pgeMaxlength: 18,
      pgeTabindex: 2,
      pgeClass: 'ocx_style',
      pgeInstallClass: 'ocx_style',
      pgeOnkeydown: '',
      pgePlach: placeHolder,
      tabCallback: 'input2',
      pgeCert:
        '3081890281810092D9D8D04FB5F8EF9B8374F21690FD46FDBF49B40EECCDF416B4E2AC2044B0CFE3BD67EB4416B26FD18C9D3833770A526FD1AB66A83ED969AF74238D6C900403FC498154EC74EAF420E7338675CAD7F19332B4A56BE4FF946B662A3C2D217EFBE4DC646FB742B8C62BFE8E25FD5DC59E7540695FA8B9CD5BFD9F92DFAD009D230203010001',
      AffineX: 'BB772F0CD268116CAB67F68BDBABBDE7E1519A3F07E9E4FF7CD3C2DB441CB8F4',
      AffineY: 'E5DCBDC66D1F7EDF4A68087ABA3EE8368CFC08101A89AF68634DDF98EC82D4DD',
      pgeWindowID: 'password' + new Date().getTime() + num,
      pgeRZRandNum: '26043592843818248016850281040623',
      pgeRZDataB: '3kgnuB5r1V4Y045V8haV3+fk08lv7m2oRnZdK0Ss0Jg='
    })
  }
}

export default pgeditorFn
